import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: ${theme.spacing.xm};
  align-items: center;
  justify-content: space-between;
  border-radius: ${theme.shapes.borderRadius.xm};
  border: 1px solid ${theme.colors.neutral.softer};
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.ion.state.focus.ghost};
`
